
document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.getElementById('PcMobileMenu');

  if (menuButton && mobileMenu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      mobileMenu.hidden = open;
    });
  }

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => select.form.submit());
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const select = form.querySelector('[data-variant-select]');
    const button = form.querySelector('[data-add-button]');
    const price = document.querySelector('[data-product-price]');

    if (!select || !button) return;

    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'ADD TO CART' : 'SOLD OUT';

      if (price) {
        const currentPrice = option.dataset.price || '';
        const comparePrice = option.dataset.comparePrice || '';
        price.innerHTML = comparePrice && comparePrice !== currentPrice
          ? `<span>${currentPrice}</span><s>${comparePrice}</s>`
          : `<span>${currentPrice}</span>`;
      }
    });
  });
});
